import { configureStore, combineReducers } from '@reduxjs/toolkit';

import accountReducer from 'slices/accountSlice';
import authReducer from 'slices/authSlice';
import categoriesReducer from 'slices/categoriesSlice';
import categoryReducer from 'slices/categorySlice';
import contactsReducer from 'slices/contactsSlice';
import documentReducer from 'slices/documentSlice';
import documentsReducer from 'slices/documentsSlice';
import navigationItemsReducer from 'slices/navigationItemsSlice';
import progressReducer from 'slices/progressSlice';
import projectReducer from 'modules/projects/slices/projectSlice';
import projectsReducer from 'modules/projects/slices/projectsSlice';
import shareablesReducer from 'slices/shareablesSlice';
import snackbarsReducer, { handleFulfilledMiddleware, handleRejectedMiddleware } from 'slices/snackbarsSlice';
import teamReducer from 'slices/teamSlice';
import teamsReducer from 'slices/teamsSlice';
import tenantsReducer from 'slices/tenantsSlice';
import usersReducer from 'slices/usersSlice';
import dashboardsReducer from 'modules/dashboards/slices/dashboardsSlice';
// TODO: handle old projects slice and rename this one
import integrationsReducer from 'slices/integrationsSlice';
import invitationsReducer from 'slices/invitationsSlice';
import scheduleReducer from 'slices/scheduleSlice';
import developmentReducer from 'slices/developmentSlice';
import appReducer from 'slices/appSlice';
import costCodesReducer from 'modules/settings/slices/costCodesSlice';
import divisionsReducer from 'modules/settings/slices/divisionsSlice';
import classificationsReducer from 'modules/settings/slices/classificationsSlice';
import phasesReducer from 'modules/settings/slices/phasesSlice';
import modalsReducer from 'slices/modalsSlice';
import downloadsReducer from 'slices/downloadsSlice';
import { routingSliceReducer } from '@sitemax/smx-components';
import { drawingReducers } from '@sitemax/smx-drawings-web';

const rootReducer = combineReducers({
    auth: authReducer,
    account: accountReducer,
    category: categoryReducer,
    categories: categoriesReducer,
    classifications: classificationsReducer,
    contacts: contactsReducer,
    costCodes: costCodesReducer,
    dashboards: dashboardsReducer,
    divisions: divisionsReducer,
    document: documentReducer,
    documents: documentsReducer,
    downloads: downloadsReducer,
    invitations: invitationsReducer,
    integrations: integrationsReducer,
    navigationItems: navigationItemsReducer,
    progress: progressReducer,
    shareables: shareablesReducer,
    snackbars: snackbarsReducer,
    tenants: tenantsReducer,
    teams: teamsReducer,
    team: teamReducer,
    phases: phasesReducer,
    projects: projectsReducer,
    project: projectReducer,
    users: usersReducer,
    schedule: scheduleReducer,
    development: developmentReducer,
    app: appReducer,
    modals: modalsReducer,
    routing: routingSliceReducer,
    ...drawingReducers,
});

export type RootState = ReturnType<typeof rootReducer>;

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        middleware: ((getDefaultMiddleware: any) =>
            getDefaultMiddleware({ thunk: true })
                .prepend(handleRejectedMiddleware.middleware)
                .prepend(handleFulfilledMiddleware.middleware)) as any,
        preloadedState,
    });
}

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export const store = setupStore({});
